import { render, staticRenderFns } from "./SortableColumn.vue?vue&type=template&id=4e572e0a&"
import script from "./SortableColumn.vue?vue&type=script&lang=js&"
export * from "./SortableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports